export default __webpack_public_path__ + "static/media/atpcare-white.864ec977.png";